module.exports = __webpack_public_path__ + "img/Conventional.34781e89.jpg";